import moment from 'moment';
import { MAX_HOURS_PER_WEEK } from '../../components/common/Constants/Constants';
import { convertToMarkup } from '../ReGexs';

export const roundToTwoDecimals = (num) => {
  if (num == null || !Number.isFinite(Number(num))) {
    return '0.00';
  }
  const roundedNumber = Math.round((Number(num) + Number.EPSILON) * 100) / 100;
  return roundedNumber.toFixed(2);
};

export const TotalHoursByDay = (timeIn, timeOut, lunch) => {
  const tin = moment(timeIn, 'hh:mm A').format('HH:mm');
  const tout = moment(timeOut, 'hh:mm A').format('HH:mm');
  const start = moment.duration(tin).asMinutes();
  let end = moment.duration(tout).asMinutes();
  const middle = lunch;
  let num = 0;
  let totalHour = 0;
  if (isNaN(middle) && start < end) {
    num = end - start;
    totalHour = num / 60;
  }
  if (isNaN(middle) && start > end) {
    end += 1440;
    num = start - end;
    totalHour = num / 60;
  }
  if (start < end) {
    num = end - start - middle;
    const atnight = num / 60;
    totalHour = atnight;
  }
  if (start > end) {
    end += 1440;
    num = end - start - middle;
    const atnight = num / 60;
    totalHour = atnight;
  }
  if (isNaN(middle) && start === end) {
    totalHour = 1440;
  }
  if (start === end) {
    num = 24 * 60 - middle;
    const atnight = num / 60;
    totalHour = atnight;
  }
  const totalRegHour = totalHour.toFixed(2);
  if (isNaN(totalRegHour)) return 0;
  return totalRegHour;
};

export const TotalHourByWeekDay = (employeesTimeEntry, day) => {
  let totalReg = 0;
  let totalOt = 0;
  employeesTimeEntry.forEach((e) => {
    if (e[day] != null) {
      totalReg += Number(e[day]?.totalRegHour) || 0;
      totalOt += Number(e[day]?.totalOtHour) || 0;
    }
  });
  if (!Number.isFinite(totalReg) || !Number.isFinite(totalOt)) {
    return '0.00';
  }
  return roundToTwoDecimals(totalReg) + ' - ' + roundToTwoDecimals(totalOt);
};

export const TotalSumAttendanceByWeek = (payroll, findDate) => {
  let totalAttendance = 0;
  Object.keys(findDate).forEach((currentDay) => {
    if (payroll[findDate[currentDay].day]?.attendance) {
      totalAttendance += 1;
    }
  });
  if (isNaN(totalAttendance)) return 0;
  return totalAttendance;
};

export const TotalSumByWeekDay = (employees, day) => {
  let totalAttendance = 0;
  employees?.forEach((e) => {
    if (e[day] !== null) {
      if (e[day]?.attendance) {
        totalAttendance = totalAttendance + 1;
      }
    }
  });
  if (isNaN(totalAttendance)) return 0;
  return totalAttendance;
};

/**
 * Adds up the weekly attendance of every employee, so the total row always matches the sum of the per-row totals.
 * @param {Array} employees - Employees of the week
 * @param {Array<{day: string, date: string}>} findDate - Days of the week, as built by useHeaderDate
 * @returns {number} Attendance total for the week
 */
export const TotalAttendanceWeek = (employees, findDate) =>
  (employees || []).reduce((total, employee) => total + TotalSumAttendanceByWeek(employee, findDate), 0);

export const calculateWeeklyTotals = (employees) => {
  let totalRegHours = 0;
  let totalOTHours = 0;
  let totalBillAmount = 0;
  let totalOTBillAmount = 0;
  let totalAmount = 0;

  const data = employees.map((employee) => {
    const { employeeTotalRegHours, employeeTotalOTHours, employeeTotalBillAmount, employeeTotalOTBillAmount } = employee;

    totalRegHours += employeeTotalRegHours || 0;
    totalOTHours += employeeTotalOTHours || 0;
    totalBillAmount += employeeTotalBillAmount || 0;
    totalOTBillAmount += employeeTotalOTBillAmount || 0;

    totalAmount = totalBillAmount + totalOTBillAmount;

    return {
      ...employee,
      totalRegHours,
      totalOTHours,
      totalBillAmount,
      totalOTBillAmount,
      totalAmount
    };
  });

  return {
    data,
    totalRegHours,
    totalOTHours,
    totalBillAmount,
    totalOTBillAmount,
    totalAmount
  };
};

export const TotalRegHourWeek = (employees) => {
  let total = 0;
  employees?.map((e) => {
    if (e.totalRegHours) {
      return (total += e.totalRegHours);
    }
    return total;
  });
  if (isNaN(total) || total === 0 || Object.is(total, -0)) return '0.00';

  return total.toFixed(2);
};

export const TotalOtHourWeek = (employees) => {
  let total = 0;
  employees?.map((e) => {
    if (e.totalOTHours) {
      return (total += e.totalOTHours);
    }
    return total;
  });
  if (isNaN(total) || total === 0 || Object.is(total, -0)) return '0.00';
  return total.toFixed(2);
};

export const TotalRegHourWeeklyPayroll = (employees) => {
  let total = 0;
  employees?.map((e) => {
    if (e.employeeTotalRegHours) {
      return (total += e.employeeTotalRegHours);
    }
    return total;
  });
  if (isNaN(total) || total === 0) return '0.00';
  return roundToTwoDecimals(total);
};

export const TotalOtHourWeeklyPayroll = (employees) => {
  let total = 0;
  employees?.map((e) => {
    if (e.employeeTotalOTHours) {
      return (total += e.employeeTotalOTHours);
    }
    return total;
  });
  if (isNaN(total) || total === 0) return parseFloat(0.0);
  return roundToTwoDecimals(total);
};

export const calculateWeeklyHours = (employee, dateStart) => {
  const startDayIndex = moment(dateStart).day();
  let currentDayIndex = startDayIndex;
  let totalRegularHours = 0;
  let totalOvertimeHours = 0;
  let totalTransportationCost = 0;

  const updatedEmployee = { ...employee };

  for (let dayCount = 0; dayCount < 7; dayCount++) {
    const weekDayName = moment().day(currentDayIndex).format('ddd').toLowerCase();
    if (!updatedEmployee[weekDayName]?.lockPayroll) {
      if (updatedEmployee[weekDayName]) {
        if (!updatedEmployee[weekDayName].totalRegHour) {
          updatedEmployee[weekDayName].totalRegHour = 0;
        }
        if (updatedEmployee[weekDayName].totalOtHour) {
          updatedEmployee[weekDayName].totalRegHour += updatedEmployee[weekDayName].totalOtHour;
          updatedEmployee[weekDayName].totalOtHour = 0;
        }
        totalRegularHours += updatedEmployee[weekDayName].totalRegHour;
        if (totalRegularHours > MAX_HOURS_PER_WEEK) {
          const extraRegularHours = MAX_HOURS_PER_WEEK - totalRegularHours;
          const extraOvertimeHours = totalRegularHours - MAX_HOURS_PER_WEEK;
          updatedEmployee[weekDayName].totalRegHour = updatedEmployee[weekDayName].totalRegHour + extraRegularHours;
          updatedEmployee[weekDayName].totalOtHour = extraOvertimeHours;
          totalRegularHours = MAX_HOURS_PER_WEEK;
          totalOvertimeHours += extraOvertimeHours;
        }
        if (
          updatedEmployee[weekDayName].totalOtHour === 0 &&
          updatedEmployee[weekDayName].totalRegHour === 0 &&
          !updatedEmployee[weekDayName].timeIn &&
          !updatedEmployee[weekDayName].timeOut
        ) {
          updatedEmployee[weekDayName].timeIn = null;
          updatedEmployee[weekDayName].timeOut = null;
          updatedEmployee[weekDayName].lunch = null;
        }
        totalTransportationCost += updatedEmployee[weekDayName].transportationCost || 0;
      }
    } else {
      if (updatedEmployee[weekDayName]) {
        if (updatedEmployee[weekDayName].totalRegHour) {
          totalRegularHours += updatedEmployee[weekDayName].totalRegHour;
        }
        if (updatedEmployee[weekDayName].totalOtHour) {
          totalOvertimeHours += updatedEmployee[weekDayName].totalOtHour;
        }
        if (updatedEmployee[weekDayName].transportationCost) {
          totalTransportationCost += updatedEmployee[weekDayName].transportationCost;
        }
      }
    }
    currentDayIndex++;
    currentDayIndex = currentDayIndex % 7;
  }

  return {
    ...updatedEmployee,
    totalRegHours: parseFloat(totalRegularHours),
    totalOTHours: parseFloat(totalOvertimeHours),
    totalTrans: parseFloat(totalTransportationCost)
  };
};

export const calculationHourWeek = (payrollWeekValidation, dateStart) => {
  const startDayIndex = moment(dateStart).day();
  const updatedEmployeeData = payrollWeekValidation.map((employee) => {
    const employeeCopy = { ...employee };
    const dayKeys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    dayKeys.forEach((dayKey) => {
      if (employeeCopy[dayKey]) {
        employeeCopy[dayKey] = { ...employeeCopy[dayKey] };
      }
    });

    let currentDayIndex = startDayIndex;
    let totalRegularHours = 0;
    let totalOvertimeHours = 0;
    let totalTransportationCost = 0;

    for (let dayCount = 0; dayCount < 7; dayCount++) {
      const weekDayName = moment().day(currentDayIndex).format('ddd').toLowerCase();
      const dayData = employeeCopy[weekDayName];
      if (!dayData?.lockPayroll) {
        if (dayData) {
          let dayReg = Number(dayData.totalRegHour) || 0;
          let dayOt = Number(dayData.totalOtHour) || 0;
          if (dayOt) {
            dayReg += dayOt;
            dayOt = 0;
          }
          dayData.totalRegHour = dayReg;
          dayData.totalOtHour = dayOt;
          totalRegularHours += dayReg;
          if (totalRegularHours > MAX_HOURS_PER_WEEK) {
            const extraRegularHours = MAX_HOURS_PER_WEEK - totalRegularHours;
            const extraOvertimeHours = totalRegularHours - MAX_HOURS_PER_WEEK;
            dayData.totalRegHour = dayReg + extraRegularHours;
            dayData.totalOtHour = extraOvertimeHours;
            totalRegularHours = MAX_HOURS_PER_WEEK;
            totalOvertimeHours += extraOvertimeHours;
          }
          if (dayData.totalOtHour === 0 && dayData.totalRegHour === 0 && !dayData.timeIn && !dayData.timeOut) {
            dayData.timeIn = null;
            dayData.timeOut = null;
            dayData.lunch = null;
          }
          totalTransportationCost += dayData.transportationCost || 0;
        }
      } else {
        if (dayData) {
          if (dayData.totalRegHour) {
            totalRegularHours += dayData.totalRegHour;
          }
          if (dayData.totalOtHour) {
            totalOvertimeHours += dayData.totalOtHour;
          }
          if (dayData.transportationCost) {
            totalTransportationCost += dayData.transportationCost;
          }
        }
      }
      currentDayIndex++;
      currentDayIndex = currentDayIndex % 7;
    }
    return {
      ...employeeCopy,
      totalRegHours: parseFloat(totalRegularHours),
      totalOTHours: parseFloat(totalOvertimeHours),
      totalTrans: parseFloat(totalTransportationCost)
    };
  });

  return updatedEmployeeData;
};

export const calculateWeeklyPayrollTotals = (payrollWeekValidation, dateStart) => {
  const numDay = moment(dateStart).day();
  const newEmployeeDetails = payrollWeekValidation.map((employee) => {
    let j = numDay;
    let employeeTotalRegHours = 0;
    let employeeTotalOTHours = 0;
    let employeeTotalBillAmount = 0;
    let employeeTotalOTBillAmount = 0;

    for (let i = 0; i < 7; i++) {
      const weekDay = moment(dateStart).day(j).format('ddd').toLowerCase();
      if (employee[weekDay]) {
        const { totalRegHour, totalOtHour, position, payRate, client } = employee[weekDay];

        // calcular la suma de dias para tener el total de semana
        employeeTotalRegHours += totalRegHour || 0;
        // calculo la suma de dias el total de horas extras
        employeeTotalOTHours += totalOtHour || 0;
        // aqui busco la position , si no tiene al
        // client para calcular el bill amount de la semana
        // que es la suma de los dias de esa operacion
        const markup = position ? convertToMarkup(position.markUp) * payRate : convertToMarkup(client.commonMarkup) * payRate;
        employeeTotalBillAmount += markup.toFixed(2) * (totalRegHour || 0);
        // al igual que markup buscamos el otmarkup para tener el total de la semana
        const otMarkup = position
          ? convertToMarkup(position.otMarkUp) * payRate * 1.5
          : convertToMarkup(client.commonOtMarkup) * payRate * 1.5;
        employeeTotalOTBillAmount += otMarkup.toFixed(2) * (totalOtHour || 0);
      }
      j = (j + 1) % 7;
    }
    // este return es por cada fila o cada payroll , y
    // esta operacion al ser un mapeo  , la hace por cada fila o cada
    // objeto del arreglo que recibo
    return {
      ...employee,
      employeeTotalRegHours,
      employeeTotalOTHours,
      employeeTotalOTBillAmount,
      employeeTotalBillAmount
    };
  });
  // retorno el calculo de todo el payroll
  return newEmployeeDetails;
};

export const totalHoursByConfig = (hours, clientReportConf) => {
  const formatHours = MAX_HOURS_PER_WEEK;
  if (clientReportConf === 3) {
    if (hours.toFixed(2) >= MAX_HOURS_PER_WEEK - 0.01 && hours.toFixed(2) <= MAX_HOURS_PER_WEEK + 0.01) {
      return formatHours?.toFixed(2);
    }
    return roundToTwoDecimals(hours);
  }
  return roundToTwoDecimals(hours);
};
